import { postData } from '@/shared/lib/axiosHelper';
import { defaultListParams } from '@/shared/model/defaultParams';
import { COMPARISON, COLUMN_DATA_TYPE } from "@/shared/constants/dataType";
import { MASTER_DATA } from '@/shared/constants/endpoint';

type Props = {
	key: string[];
	api: () => Promise<any>;
};

interface params extends defaultListParams {
	endpoint: string;
}

function fetchList({
	endpoint,
	page_number = 1,
	page_size = 10,
	sort_by,
	sort_direction,
	criteria = {
		logical: 'AND',
		conditions: []
	},
	...params
}: params): Props {
	let conditions: any[] = (Array.isArray(criteria.conditions) ? criteria.conditions : [criteria.conditions])
		.filter(item => item?.name && item?.value)
		.map(item => ({
			...item,
			column_data_type: item?.column_data_type || COLUMN_DATA_TYPE.STRING,
			comparison: item?.comparison || COMPARISON.LIKE
		}));

	const updatedCriteria = {
		logical: criteria.logical ?? 'AND',
		conditions
	};

	const KEY = [
		endpoint,
		`PAGE-${page_number}`,
		`SIZE-${page_size}`,
		`SORTBY-${sort_by || 'default'}`,
		`SORTDIR-${sort_direction || 'ASC'}`,
		JSON.stringify(updatedCriteria),
		JSON.stringify(params)
	];

	// if (params?.cabinet_id) KEY.push(`CABINET-ID-${params?.cabinet_id}`)
	// if (driver_id) KEY.push(`DRIVER-ID-${driver_id}`)
	// if (transaction_rent_motorcycle_id) KEY.push(`TRX-R-M-ID-${transaction_rent_motorcycle_id}`)

	const API = async () => {
		const result = await postData({
			endpoint,
			data: {
				page_number,
				page_size,
				sort_by,
				sort_direction,
				criteria: updatedCriteria,
				...params
			}
		});
		return result?.data?.data;
	};

	return { key: KEY, api: API };
}

export {
	fetchList,
};
